import { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { getActivePO } from '../lib/storeMode';
import { useCart } from '../context/CartContext';

const BRAND_NAME = process.env.REACT_APP_BRAND_NAME || 'HAPin';

export default function StoreNav() {
  const { totalQty } = useCart();
  const nav = useNavigate();
  const location = useLocation();
  const [productId, setProductId] = useState(null);
  const [poActive, setPoActive] = useState(null); // null = belum dicek, true/false setelahnya

  useEffect(() => {
    getActivePO().then(po => {
      if (po?.product) { setProductId(po.product.id); setPoActive(true); }
      else setPoActive(false);
    });
  }, []);

  function goOrder() {
    if (poActive && productId) nav(`/product/${productId}`);
    else if (location.pathname === '/') document.getElementById('menu')?.scrollIntoView({ behavior: 'smooth' });
    else nav('/#menu');
  }

  return (
    <div style={{ position: 'sticky', top: 0, zIndex: 40, padding: '14px 16px 0' }}>
      <nav style={{
        maxWidth: 1040, margin: '0 auto', background: 'var(--ink)',
        borderRadius: 999, padding: '10px 10px 10px 22px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        boxShadow: '0 8px 30px rgba(33,23,16,.18)',
      }}>
        <Link to="/" style={{ fontFamily: "'Baloo 2',sans-serif", fontWeight: 700, fontSize: '1.3rem', color: '#FBF7F1' }}>
          {BRAND_NAME}
        </Link>

        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <button onClick={() => nav('/cart')} aria-label="Keranjang" style={{
            position: 'relative', width: 38, height: 38, borderRadius: '50%',
            background: 'rgba(251,247,241,.1)', border: '1px solid rgba(251,247,241,.14)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#FBF7F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
            </svg>
            {totalQty > 0 && (
              <span style={{
                position: 'absolute', top: -3, right: -3, minWidth: 17, height: 17, padding: '0 3px',
                borderRadius: 999, background: 'var(--primary)', color: '#fff',
                fontSize: '.62rem', fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontFamily: "'DM Sans',sans-serif",
              }}>{totalQty}</span>
            )}
          </button>
          <button onClick={goOrder} style={{
            background: 'var(--primary)', color: '#fff', border: 'none', borderRadius: 999,
            padding: '9px 20px', fontSize: '.8rem', fontWeight: 700, letterSpacing: '.3px',
          }}>
            Order
          </button>
        </div>
      </nav>
    </div>
  );
}
